import { httpClient } from '@/utils/http'
export class VipAPI {
  static async getVipPerks(): Promise<any> {
    return httpClient.post<any>('/getVipPerks')
  }
  static async getSubscribePackagesCount(): Promise<any> {
    return httpClient.post<any>('/getSubscribePackagesCount')
  }
}
